const useElementUIPaginationMixin = {
  data() {
    return {
      $_useElementUIPaginationMixin_list: [],
      $_useElementUIPaginationMixin_listQuery: {
        keyword: '',
        page: 1,
        size: 50,
        sizes: [50, 100, 200],
        total: 0,
      },
      $_useElementUIPaginationMixin_isLoading: true,
    }
  },
  methods: {
    $_useElementUIPaginationMixin_handleSizeChange(size) {
      this.$data.$_useElementUIPaginationMixin_listQuery.size = size
      this.$_useElementUIPaginationMixin_getList()
    },
    $_useElementUIPaginationMixin_handlePageChange(page) {
      if (this.$data.$_useElementUIPaginationMixin_listQuery.page === page) {
        return
      }

      this.$data.$_useElementUIPaginationMixin_listQuery.page = page
      this.$_useElementUIPaginationMixin_getList()
    },
    $_useElementUIPaginationMixin_getList() {
      // You must implement this method in your component to
      // handle list fetching
    },
  },
}

export default useElementUIPaginationMixin
